import ApiService from "@/services/api.service";

const route = 'extra_rewards';

const actions = {
    query(_fields) {
        return new Promise((resolve, reject) => {
            ApiService.query(route, _fields).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },

    update(_fields) {
        return new Promise((resolve, reject) => {
            ApiService.post(route, _fields).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
};

export default actions;